import { BASE_URL } from "config";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import myTransctionWalletTableData from "./data/myTransctionWalletTableData";
import TextField from "@mui/material/TextField";
import { useMaterialUIController, setDirection } from "context";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { Height, PaddingTwoTone } from "@mui/icons-material";
import { margin, padding, width } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Swal from "sweetalert2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import OutboundIcon from "@mui/icons-material/Outbound";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function MyWallet() {
  const [controller, dispatch] = useMaterialUIController();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [walletLoading, setWalletLoading] = useState(true);
  const [topups, setTopups] = useState([]);
  const [topupsLoading, setTopupsLoading] = useState(false);

  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const [openChargeDialog, setOpenChargeDialog] = useState(false);
  const [chargeAmount, setChargeAmount] = useState("");
  const [chargeMethod, setChargeMethod] = useState("");
  const [chargeError, setChargeError] = useState("");
  const [chargeReference, setChargeReference] = useState("");
  const [chargeCardMethod, setChargeCardMethod] = useState("visa");
  const [chargeErrors, setChargeErrors] = useState({});

  const [pageLoading, setPageLoading] = useState(true);

  const [openTransferDialog, setOpenTransferDialog] = useState(false);
  const [transferAmount, setTransferAmount] = useState("");
  const [transferCode, setTransferCode] = useState("");
  const [transferErrors, setTransferErrors] = useState({});

  const [openWithdrawDialog, setOpenWithdrawDialog] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [withdrawBank, setWithdrawBank] = useState("");
  const [withdrawErrors, setWithdrawErrors] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);

  const [withdrawals, setWithdrawals] = useState([]);
  const [withdrawalsLoading, setWithdrawalsLoading] = useState(false);

  const [walletCode, setWalletCode] = useState("");
  const [walletCodeLoading, setWalletCodeLoading] = useState(false);
  const [walletCodeVisible, setWalletCodeVisible] = useState(false);
  const [walletCodeError, setWalletCodeError] = useState("");

  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };

  useEffect(() => {
    setDirection(dispatch, "rtl");
    setPageLoading(true);
    Promise.all([fetchUsers(), fetchWallet(), fetchTopups(), fetchWalletCode()]).finally(() =>
      setPageLoading(false)
    );
    return () => setDirection(dispatch, "ltr");
  }, []);
  // get all wallet transfers
  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallet-transfers", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchWallet = async () => {
    setWalletLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallets", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setWallet(data.data);
    } catch (error) {
      setWallet(null);
    } finally {
      setWalletLoading(false);
    }
  };

  const fetchTopups = async () => {
    setTopupsLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallet-topups", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data.status && Array.isArray(data.data)) {
        setTopups(data.data);
      } else {
        setTopups([]);
      }
    } catch (error) {
      setTopups([]);
    } finally {
      setTopupsLoading(false);
    }
  };

  const fetchWalletCode = async () => {
    setWalletCodeLoading(true);
    setWalletCodeError("");
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallets/get-code", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("فشل في جلب كود المحفظة");
      const code = await response.text();
      setWalletCode(code);
    } catch (e) {
      setWalletCode("");
      setWalletCodeError("تعذر جلب كود المحفظة");
    } finally {
      setWalletCodeLoading(false);
    }
  };

  const { columns, rows } = myTransctionWalletTableData(users);

  // فلترة حسب الاسم أو رقم العملية أو المرسل أو المستلم
  const filteredRows = rows.filter(
    (row) =>
      (row.from && row.from.toLowerCase().includes(search.toLowerCase())) ||
      (row.to && row.to.toLowerCase().includes(search.toLowerCase())) ||
      (row.id && String(row.id).includes(search))
  );

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث
  }, [search]);

  const handleOpenChargeDialog = () => {
    setChargeAmount("");
    setChargeMethod("");
    setChargeReference("");
    setChargeCardMethod("visa");
    setChargeErrors({});
    setOpenChargeDialog(true);
  };
  const handleCloseChargeDialog = () => setOpenChargeDialog(false);

  const handleChargeSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    if (!chargeAmount || isNaN(chargeAmount) || Number(chargeAmount) <= 0) {
      errors.chargeAmount = "يرجى إدخال مبلغ صحيح";
    }
    if (!chargeMethod) {
      errors.chargeMethod = "يرجى اختيار طريقة الشحن";
    }
    if (chargeMethod === "bank_transfer" && !chargeReference.trim()) {
      errors.chargeReference = "يرجى إدخال الرقم المرجعي للتحويل البنكي";
    }
    if (chargeMethod === "card" && !chargeCardMethod) {
      errors.chargeCardMethod = "يرجى اختيار طريقة الدفع للبطاقة";
    }
    setChargeErrors(errors);
    if (Object.keys(errors).length > 0) return;

    Swal.fire({
      title: "جاري الشحن...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        const container = document.querySelector(".swal2-container");
        if (container) container.style.zIndex = "99999";
      },
    });

    // تجهيز البيانات للإرسال
    const payload = {
      amount: Number(chargeAmount),
      method: chargeMethod,
    };
    if (chargeMethod === "bank_transfer") {
      payload.reference = chargeReference;
    }
    if (chargeMethod === "card") {
      payload.payment_method_id = Number(chargeCardMethod); // 1: VISA, 2: STCPay, 3: PayPal
    }

    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallet-topups/store", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      Swal.close();
      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "تم الشحن بنجاح!",
          text: "تمت  شحن المحفظة بنجاح.",
          confirmButtonText: "موافق",
        });
        handleAfterCharge();
      } else {
        Swal.fire({
          icon: "error",
          title: "فشل الشحن!",
          text: data.message || "حدث خطأ أثناء عملية الشحن.",
          confirmButtonText: "موافق",
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "فشل الشحن!",
        text: error.message || "حدث خطأ أثناء الاتصال بالخادم.",
        confirmButtonText: "موافق",
      });
    }
  };

  // بطاقة المحفظة
  const WalletCard = () => (
    <MDBox display="flex" justifyContent="flex-end" mt={4} mb={2}>
      <div
        style={{
          minWidth: 300,
          maxWidth: 300,
          marginLeft: "auto",
          marginRight: 0,
          padding: 16,
          borderRadius: 14,
          boxShadow: "0 4px 16px 0 rgba(31, 38, 135, 0.18)",
          background: "linear-gradient(135deg, #232526 0%,rgb(52, 50, 50) 30%, #616161 100%)",
          color: "white",
          position: "relative",
          overflow: "visible",
          minHeight: 140,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <MDBox display="flex" alignItems="center" gap={1} mb={1}>
          <CreditCardIcon sx={{ fontSize: 28, opacity: 0.8, color: "white !important" }} />
          <MDTypography
            variant="subtitle1"
            fontWeight="bold"
            style={{ color: "white", fontWeight: "bold" }}
          >
            محفظة المتجر
          </MDTypography>
        </MDBox>
        {/* Wallet Code Section */}
        <MDBox display="flex" alignItems="center" gap={1} mb={1}>
          <MDTypography variant="caption" fontWeight="medium" style={{ color: "white" }}>
            الكود:
          </MDTypography>
          {walletCodeLoading ? (
            <CircularProgress size={16} sx={{ color: "#e0b15a !important" }} />
          ) : walletCodeError ? (
            <MDTypography color="error" fontSize={13}>
              {walletCodeError}
            </MDTypography>
          ) : walletCode ? (
            <MDBox display="flex" alignItems="center" gap={0.5}>
              <MDTypography
                variant="caption"
                fontWeight="bold"
                style={{
                  letterSpacing: 1,
                  fontFamily: "monospace",
                  background: "rgba(255,255,255,0.08)",
                  borderRadius: 4,
                  padding: "2px 8px",
                  color: "#fff",
                  userSelect: "all",
                  fontSize: 15,
                }}
              >
                {walletCodeVisible ? walletCode : "*".repeat(walletCode.length)}
              </MDTypography>
              <IconButton
                size="small"
                sx={{ color: "#fff" }}
                onClick={() => setWalletCodeVisible((v) => !v)}
                aria-label={walletCodeVisible ? "إخفاء الكود" : "إظهار الكود"}
              >
                {walletCodeVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
              <IconButton
                size="small"
                sx={{ color: "#fff" }}
                onClick={() => {
                  navigator.clipboard.writeText(walletCode);
                  Swal.fire({
                    toast: true,
                    position: "center",
                    icon: "success",
                    title: "تم نسخ الكود!",
                    showConfirmButton: false,
                    timer: 1200,
                  });
                }}
                aria-label="نسخ الكود"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </MDBox>
          ) : null}
        </MDBox>
        {/* End Wallet Code Section */}
        {walletLoading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight={40}>
            <CircularProgress size={22} sx={{ color: "white !important" }} />
          </MDBox>
        ) : wallet ? (
          <>
            <MDTypography
              variant="h6"
              fontWeight="bold"
              mb={0.5}
              style={{ color: "white", fontWeight: "bold" }}
            >
              {wallet.balance} {wallet.currency?.code || ""}
            </MDTypography>
            <MDTypography variant="caption" fontWeight="medium" mb={0.5} style={{ color: "white" }}>
              العملة: {wallet.currency?.name || "-"}
            </MDTypography>
            <MDTypography variant="caption" fontWeight="medium" style={{ color: "white" }}>
              حالة المحفظة: {wallet.status === "active" ? "مفعلة" : "غير مفعلة"}
            </MDTypography>
            <MDBox display="flex" gap={1} mt={2}>
              <MDButton
                variant="contained"
                color="success"
                sx={{
                  background: "linear-gradient(90deg, #43cea2, #185a9d)",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: 1.5,
                  boxShadow: "0 1px 4px rgba(67, 206, 162, 0.12)",
                  px: 2,
                  py: 0.5,
                  fontSize: 13,
                  minWidth: 0,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  transition: "0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #185a9d, #43cea2)",
                  },
                }}
                startIcon={<AttachMoneyIcon sx={{ fontSize: 18 }} />}
                onClick={handleOpenChargeDialog}
              >
                شحن
              </MDButton>
              <MDButton
                variant="contained"
                color="info"
                sx={{
                  background: "linear-gradient(90deg, #f7971e, #ffd200)",
                  color: "#232526",
                  fontWeight: "bold",
                  borderRadius: 1.5,
                  boxShadow: "0 1px 4px rgba(247, 151, 30, 0.12)",
                  px: 2,
                  py: 0.5,
                  fontSize: 13,
                  minWidth: 0,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  transition: "0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #ffd200, #f7971e)",
                  },
                }}
                startIcon={<CompareArrowsIcon sx={{ fontSize: 18 }} />}
                onClick={handleOpenTransferDialog}
              >
                تحويل
              </MDButton>
              <MDButton
                variant="contained"
                color="error"
                sx={{
                  background: "linear-gradient(90deg, #e53935, #e35d5b)",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: 1.5,
                  boxShadow: "0 1px 4px rgba(229, 57, 53, 0.12)",
                  px: 2,
                  py: 0.5,
                  fontSize: 13,
                  minWidth: 0,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  transition: "0.2s",
                  "&:hover": {
                    background: "linear-gradient(90deg, #e35d5b, #e53935)",
                  },
                }}
                startIcon={<OutboundIcon sx={{ fontSize: 18 }} />}
                onClick={handleOpenWithdrawDialog}
              >
                سحب
              </MDButton>
            </MDBox>
          </>
        ) : (
          <MDTypography color="error" style={{ color: "white" }}>
            تعذر تحميل بيانات المحفظة
          </MDTypography>
        )}
      </div>
    </MDBox>
  );

  // بعد الشحن الناجح
  const handleAfterCharge = () => {
    setOpenChargeDialog(false);
    fetchWallet();
    fetchTopups();
  };

  // تجهيز أعمدة وصفوف DataTable لعمليات الشحن
  const topupsColumns = [
    { Header: "المبلغ", accessor: "amount", align: "center" },
    { Header: "الطريقة", accessor: "method", align: "center" },
    { Header: "طريقة الدفع (id)", accessor: "payment_method_id", align: "center" },
    { Header: "الرقم المرجعي", accessor: "reference", align: "center" },
    { Header: "الحالة", accessor: "status", align: "center" },
    { Header: "التاريخ", accessor: "created_at", align: "center" },
  ];

  const topupsRows = topups.map((row) => ({
    amount: row.amount,
    method:
      row.method === "cash" ? "نقدي" : row.method === "bank_transfer" ? "تحويل بنكي" : "بطاقة",
    payment_method_id: row.method === "card" && row.payment_method_id ? row.payment_method_id : "-",
    reference: row.reference || "-",
    status:
      row.status === "pending" ? (
        <span style={{ color: "#e0b15a", fontWeight: "bold" }}>قيد المعالجة</span>
      ) : row.status === "completed" ? (
        <span style={{ color: "#43cea2", fontWeight: "bold" }}>مكتمل</span>
      ) : row.status === "rejected" ? (
        <span style={{ color: "#e57373", fontWeight: "bold" }}>مرفوض</span>
      ) : (
        row.status
      ),
    created_at: row.created_at ? new Date(row.created_at).toLocaleString("ar-EG") : "-",
  }));

  const handleOpenTransferDialog = () => {
    setTransferAmount("");
    setTransferCode("");
    setTransferErrors({});
    setOpenTransferDialog(true);
  };
  const handleCloseTransferDialog = () => setOpenTransferDialog(false);

  const handleTransferSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    if (!transferAmount || isNaN(transferAmount) || Number(transferAmount) <= 0) {
      errors.amount = "يرجى إدخال مبلغ صحيح";
    }
    if (!transferCode.trim()) {
      errors.code = "يرجى إدخال الكود";
    }
    setTransferErrors(errors);
    if (Object.keys(errors).length > 0) return;

    Swal.fire({
      title: "جاري التحويل...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        const container = document.querySelector(".swal2-container");
        if (container) container.style.zIndex = "99999";
      },
    });

    const payload = {
      amount: Number(transferAmount),
      code: transferCode.trim(),
    };
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallet-transfers/store", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      Swal.close();
      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحويل بنجاح!",
          text: "تمت عملية التحويل بنجاح.",
          confirmButtonText: "موافق",
        });
        setOpenTransferDialog(false);
        fetchWallet();
        fetchTopups();
      } else {
        Swal.fire({
          icon: "error",
          title: "فشل التحويل!",
          text: data.message || "حدث خطأ أثناء عملية التحويل.",
          confirmButtonText: "موافق",
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "فشل التحويل!",
        text: error.message || "حدث خطأ أثناء الاتصال بالخادم.",
        confirmButtonText: "موافق",
      });
    }
  };

  // جلب الحسابات البنكية عند فتح Dialog السحب
  const handleOpenWithdrawDialog = async () => {
    setWithdrawAmount("");
    setWithdrawBank("");
    setWithdrawErrors({});
    setBankLoading(true);
    setOpenWithdrawDialog(true);
    try {
      const token = localStorage.getItem("user-token");
      const response = await fetch(BASE_URL + "/manager/bank-accounts", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data.status && Array.isArray(data.data)) {
        setBankAccounts(data.data);
        // اختر الافتراضي تلقائياً
        const def = data.data.find((b) => b.is_default) || data.data[0];
        setWithdrawBank(def ? def.id : "");
      } else {
        setBankAccounts([]);
      }
    } catch (e) {
      setBankAccounts([]);
    } finally {
      setBankLoading(false);
    }
  };
  const handleCloseWithdrawDialog = () => setOpenWithdrawDialog(false);

  // إرسال طلب السحب
  const handleWithdrawSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    if (!withdrawAmount || isNaN(withdrawAmount) || Number(withdrawAmount) <= 0) {
      errors.amount = "يرجى إدخال مبلغ صحيح";
    }
    if (!withdrawBank) {
      errors.bank = "يرجى اختيار الحساب البنكي";
    }
    setWithdrawErrors(errors);
    if (Object.keys(errors).length > 0) return;
    Swal.fire({
      title: "جاري السحب...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        const container = document.querySelector(".swal2-container");
        if (container) container.style.zIndex = "99999";
      },
    });
    const payload = {
      amount: Number(withdrawAmount),
      bank_account_id: withdrawBank,
      method: "bank_transfer",
    };
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallet-withdrawals/store", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      Swal.close();
      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "تم السحب بنجاح!",
          text: "تمت عملية السحب بنجاح.",
          confirmButtonText: "موافق",
        });
        handleAfterWithdraw();
      } else {
        Swal.fire({
          icon: "error",
          title: "فشل السحب!",
          text: data.message || "حدث خطأ أثناء عملية السحب.",
          confirmButtonText: "موافق",
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "فشل السحب!",
        text: error.message || "حدث خطأ أثناء الاتصال بالخادم.",
        confirmButtonText: "موافق",
      });
    }
  };

  // جلب عمليات السحب
  const fetchWithdrawals = async () => {
    setWithdrawalsLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/wallet-withdrawals", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data.status && Array.isArray(data.data)) {
        setWithdrawals(data.data);
      } else {
        setWithdrawals([]);
      }
    } catch (e) {
      setWithdrawals([]);
    } finally {
      setWithdrawalsLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  // بعد السحب الناجح
  const handleAfterWithdraw = () => {
    setOpenWithdrawDialog(false);
    fetchWallet();
    fetchTopups();
    fetchWithdrawals();
  };

  // أعمدة وجدول عمليات السحب
  const withdrawalsColumns = [
    { Header: "رقم العملية", accessor: "id", align: "center" },
    { Header: "المبلغ", accessor: "amount", align: "center" },
    { Header: "اسم البنك", accessor: "bank_name", align: "center" },
    { Header: "رقم الحساب", accessor: "bank_account", align: "center" },
    { Header: "الطريقة", accessor: "method", align: "center" },
    { Header: "الحالة", accessor: "status", align: "center" },
    { Header: "التاريخ", accessor: "created_at", align: "center" },
  ];
  const withdrawalsRows = withdrawals.map((row) => ({
    id: row.id,
    amount: row.amount,
    bank_name: row.bank_account?.name || "-",
    bank_account: row.bank_account?.account || "-",
    method:
      row.method === "bank_transfer" ? "تحويل بنكي" : row.method === "cash" ? "نقدي" : row.method,
    status:
      row.status === "pending" ? (
        <span style={{ color: "#e0b15a", fontWeight: "bold" }}>قيد المعالجة</span>
      ) : row.status === "processed" ? (
        <span style={{ color: "#43cea2", fontWeight: "bold" }}>مكتمل</span>
      ) : row.status === "rejected" ? (
        <span style={{ color: "#e57373", fontWeight: "bold" }}>مرفوض</span>
      ) : (
        row.status
      ),
    created_at: row.created_at ? new Date(row.created_at).toLocaleString("ar-EG") : "-",
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {pageLoading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          zIndex={99999}
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ background: "rgba(255,255,255,0.7)" }}
        >
          <CircularProgress size={70} sx={{ color: "#ca9937" }} />
        </Box>
      )}
      <MDBox
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        gap={4}
        alignItems={{ xs: "stretch", md: "flex-start" }}
        justifyContent="flex-end"
        mt={4}
        mb={2}
      >
        <Box
          sx={{
            width: { xs: "100%", md: 300 },
            maxWidth: { xs: "100%", md: 300 },
            minWidth: { xs: "unset", md: 300 },
            mb: { xs: 2, md: 0 },
          }}
        >
          <WalletCard />
        </Box>
        <Card
          sx={{
            minWidth: { xs: "unset", md: 500 },
            width: { xs: "100%", md: "auto" },
            boxShadow: 2,
            borderRadius: 2,
            flex: 1,
          }}
        >
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #232526, #616161)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              عمليات شحن المحفظة
            </MDTypography>
          </MDBox>
          {topupsRows.length === 0 && !topupsLoading ? (
            <MDTypography color="text" align="center" fontWeight="bold" py={4}>
              لا توجد عمليات شحن
            </MDTypography>
          ) : (
            <Box sx={{ maxHeight: 300, minHeight: 200, overflowY: "auto", overflowX: "auto" }}>
              <DataTable
                table={{ columns: topupsColumns, rows: topupsRows }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={true}
                noEndBorder
                loading={topupsLoading}
                sx={{
                  "& .MuiTable-root": { minWidth: 500 },
                  "& .MuiTableCell-root": {
                    py: 1.5,
                    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                  },
                  "& .MuiTableHead-root": {
                    backgroundColor: (theme) => theme.palette.grey[100],
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                  },
                }}
              />
            </Box>
          )}
        </Card>
      </MDBox>
      <MDBox mt={2} mb={2}>
        <Card
          sx={{
            minWidth: { xs: "unset", md: 500 },
            width: { xs: "100%", md: "auto" },
            boxShadow: 2,
            borderRadius: 2,
            flex: 1,
            paddingTop: 20,
          }}
        >
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #232526, #616161)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              عمليات سحب المحفظة
            </MDTypography>
          </MDBox>
          {withdrawalsRows.length === 0 && !withdrawalsLoading ? (
            <MDTypography color="text" align="center" fontWeight="bold" py={4}>
              لا توجد عمليات سحب
            </MDTypography>
          ) : (
            <Box sx={{ maxHeight: 300, minHeight: 200, overflowY: "auto", overflowX: "auto" }}>
              <DataTable
                table={{ columns: withdrawalsColumns, rows: withdrawalsRows }}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={true}
                noEndBorder
                loading={withdrawalsLoading}
                sx={{
                  "& .MuiTable-root": { minWidth: 500 },
                  "& .MuiTableCell-root": {
                    py: 1.5,
                    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                  },
                  "& .MuiTableHead-root": {
                    backgroundColor: (theme) => theme.palette.grey[100],
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                  },
                }}
              />
            </Box>
          )}
        </Card>
      </MDBox>
      <Dialog open={openChargeDialog} onClose={handleCloseChargeDialog} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          شحن المحفظة
          <IconButton onClick={handleCloseChargeDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleChargeSubmit}>
            <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
              <TextField
                label="المبلغ"
                type="number"
                value={chargeAmount}
                onChange={(e) => setChargeAmount(e.target.value)}
                fullWidth
                inputProps={{ min: 10 }}
                error={!!chargeErrors.chargeAmount}
                helperText={chargeErrors.chargeAmount}
              />
              <FormControl fullWidth error={!!chargeErrors.chargeMethod}>
                <InputLabel id="charge-method-label">طريقة الشحن</InputLabel>
                <Select
                  labelId="charge-method-label"
                  value={chargeMethod}
                  label="طريقة الشحن"
                  onChange={(e) => setChargeMethod(e.target.value)}
                  sx={{ height: 35 }}
                >
                  <MenuItem value="cash">نقدي</MenuItem>
                  <MenuItem value="bank_transfer">تحويل بنكي</MenuItem>
                  <MenuItem value="card">بطاقة</MenuItem>
                </Select>
                {chargeErrors.chargeMethod && (
                  <MDTypography color="error" fontSize={13} textAlign="right" mt={0.5}>
                    {chargeErrors.chargeMethod}
                  </MDTypography>
                )}
              </FormControl>
              {chargeMethod === "bank_transfer" && (
                <TextField
                  label="الرقم المرجعي للتحويل البنكي"
                  value={chargeReference}
                  onChange={(e) => setChargeReference(e.target.value)}
                  fullWidth
                  error={!!chargeErrors.chargeReference}
                  helperText={chargeErrors.chargeReference}
                />
              )}
              {chargeMethod === "card" && (
                <FormControl fullWidth error={!!chargeErrors.chargeCardMethod}>
                  <InputLabel id="card-method-label">طريقة الدفع</InputLabel>
                  <Select
                    labelId="card-method-label"
                    value={chargeCardMethod}
                    label="طريقة الدفع"
                    onChange={(e) => setChargeCardMethod(e.target.value)}
                    sx={{ height: 35 }}
                  >
                    <MenuItem value="1">VISA</MenuItem>
                    <MenuItem value="2">STCPay</MenuItem>
                    <MenuItem value="3">PayPal</MenuItem>
                  </Select>
                  {chargeErrors.chargeCardMethod && (
                    <MDTypography color="error" fontSize={13} textAlign="right" mt={0.5}>
                      {chargeErrors.chargeCardMethod}
                    </MDTypography>
                  )}
                </FormControl>
              )}
              <MDButton
                type="submit"
                variant="gradient"
                color="success"
                fullWidth
                sx={{ mt: 1, fontWeight: "bold", fontSize: 15 }}
              >
                تأكيد الشحن
              </MDButton>
            </MDBox>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog open={openTransferDialog} onClose={handleCloseTransferDialog} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          تحويل إلى محفظة
          <IconButton onClick={handleCloseTransferDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleTransferSubmit}>
            <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
              <TextField
                label="المبلغ"
                type="number"
                value={transferAmount}
                onChange={(e) => setTransferAmount(e.target.value)}
                fullWidth
                error={!!transferErrors.amount}
                helperText={transferErrors.amount}
              />
              <TextField
                label="الكود"
                value={transferCode}
                onChange={(e) => setTransferCode(e.target.value)}
                fullWidth
                error={!!transferErrors.code}
                helperText={transferErrors.code}
              />
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                sx={{ mt: 1, fontWeight: "bold", fontSize: 15 }}
                startIcon={<SwapHorizIcon />}
              >
                تأكيد التحويل
              </MDButton>
            </MDBox>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog open={openWithdrawDialog} onClose={handleCloseWithdrawDialog} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          سحب من المحفظة
          <IconButton onClick={handleCloseWithdrawDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleWithdrawSubmit}>
            <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
              <TextField
                label="المبلغ"
                type="number"
                value={withdrawAmount}
                onChange={(e) => setWithdrawAmount(e.target.value)}
                fullWidth
                error={!!withdrawErrors.amount}
                helperText={withdrawErrors.amount}
              />
              <FormControl fullWidth error={!!withdrawErrors.bank}>
                <InputLabel id="withdraw-bank-label">الحساب البنكي</InputLabel>
                <Select
                  labelId="withdraw-bank-label"
                  value={withdrawBank}
                  label="الحساب البنكي"
                  onChange={(e) => setWithdrawBank(e.target.value)}
                  sx={{ height: 35 }}
                  disabled={bankLoading}
                >
                  {bankAccounts.length === 0 && !bankLoading && (
                    <MenuItem value="">لا يوجد حسابات بنكية</MenuItem>
                  )}
                  {bankAccounts.map((acc) => (
                    <MenuItem key={acc.id} value={acc.id}>
                      {acc.name} - {acc.account}
                    </MenuItem>
                  ))}
                </Select>
                {withdrawErrors.bank && (
                  <MDTypography color="error" fontSize={13} textAlign="right" mt={0.5}>
                    {withdrawErrors.bank}
                  </MDTypography>
                )}
              </FormControl>
              <MDButton
                type="submit"
                variant="gradient"
                color="error"
                fullWidth
                sx={{ mt: 1, fontWeight: "bold", fontSize: 15 }}
                startIcon={<OutboundIcon />}
                disabled={bankLoading}
              >
                تأكيد السحب
              </MDButton>
            </MDBox>
          </form>
        </DialogContent>
      </Dialog>
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              العمليات التي تمت
            </MDTypography>
          </MDBox>

          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="300px"
              py={6}
            >
              <CircularProgress size={60} sx={{ color: "#ca9937" }} />
            </Box>
          ) : (
            <>
              <MDBox pt={3} px={2}>
                <TextField
                  fullWidth
                  label="بحث بالاسم أو رقم العملية"
                  variant="outlined"
                  size="small"
                  sx={{ mb: 3 }}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <Box sx={{ maxHeight: 400, minHeight: 200, overflowY: "auto" }}>
                  <DataTable
                    table={{ columns, rows: filteredRows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={true}
                    noEndBorder
                    sx={{
                      "& .MuiTable-root": { minWidth: 1000 },
                      "& .MuiTableCell-root": {
                        py: 1.5,
                        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                      },
                      "& .MuiTableHead-root": {
                        backgroundColor: (theme) => theme.palette.grey[100],
                      },
                    }}
                  />
                </Box>
              </MDBox>
            </>
          )}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default MyWallet;
